// extracted by mini-css-extract-plugin
module.exports = {"modalText":"_3QlA7b8horRV1097DREbct","title":"hX0amMRzg_5cBWV9mX5Eg"};